export default __webpack_public_path__ + "static/media/hht1_ani_17.f2ee4425.png";